import { ContentItem } from 'kentico-cloud-delivery';

import get from 'lodash/get';

export default class ProductSlide extends ContentItem {
  constructor() {
    super({
      propertyResolver: fieldName => `_${fieldName}`,
    });
  }

  get content() {
    return get(this, '_content', {});
  }

  get bottomImage() {
    return get(this, '_bottom_image.value[0].url', '');
  }

  get slug() {
    return get(this, '_product_slugs.taxonomyTerms[0].name', '/');
  }
}



// WEBPACK FOOTER //
// ./src/models/ProductSlide.model.js